<template>
  <div class="page">
    <div style="
      margin: auto;
      width: 1200px;
      height: 110px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'首页'"/>
      </div>
    </div>
    <div style="width: 1200px;margin: auto;">

      <div v-if="car && routelist[0].visible==1" style="margin-top: 10px;">
        <div style="float: right">
          <el-button style="
          width: 0px;
          padding: 0px;
          position: relative;
             left:-30px;
              top:10px;
               z-index: 1000 ;border: 0;
               background-color: unset;color: #FFFFFF
                " @click="carousel">×
          </el-button>
        </div>
        <div class="block">
          <el-carousel height="320px">
            <el-carousel-item v-for="item in jp_list" :key="item">
              <img style="width: 100%;height: 320px" :src="item" alt="">
            </el-carousel-item>
          </el-carousel>
          <!--          <el-image :src="require('@/assets/image/shouye.jpg')" style="width: 100%;height: 320px"></el-image>-->
        </div>
      </div>

      <div class="searchBar box mt20">
        <div class="search-box clear">
          <div class="typeList">
            <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
    {{ command }}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="全部" style="float: none !important;padding: 0 20px">全部</el-dropdown-item>
                <el-dropdown-item command="国家标准" style="float: none !important;padding: 0 20px">国家标准
                </el-dropdown-item>
                <el-dropdown-item command="行业标准" style="float: none !important;padding: 0 20px">行业标准
                </el-dropdown-item>
                <el-dropdown-item command="地方标准" style="float: none !important;padding: 0 20px">地方标准
                </el-dropdown-item>
                <el-dropdown-item command="团体标准" style="float: none !important;padding: 0 20px">团体标准
                </el-dropdown-item>
                <el-dropdown-item command="国际国外标准" style="float: none !important;padding: 0 20px">国际国外标准
                </el-dropdown-item>
                <el-dropdown-item command="工程标准" style="float: none !important;padding: 0 20px">工程标准
                </el-dropdown-item>
                <el-dropdown-item command="技术规范" style="float: none !important;padding: 0 20px">技术规范
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <input v-model="input" class="inputSearch" type="text" placeholder="请输入标准号或标准名称查询"
                 @keyup.enter.native="toSearch"/>
          <input @click="toSearch" type="button" class="btnSearch" value=""/>
        </div>
      </div>

      <!--      G	国家标准
            C	行业标准
            D	地方标准
            T	团体标准
            N	国际国外标准
            J	工程标准-->
      <!--      <el-card style="margin-top: 20px;">-->
      <!--        <el-input-->
      <!--          v-model="input"-->
      <!--          class="inpu"-->
      <!--          placeholder="请输入标准号或标准名称查询"-->
      <!--          style="width: 1160px; "-->
      <!--        >-->
      <!--        </el-input>-->

      <!--        <div class="butt" style="float: right">-->
      <!--          <el-button-->
      <!--            style="width: 20px;-->
      <!--          height: 20px;-->
      <!--          padding: 0px;-->
      <!--          position: relative;-->
      <!--             left:-15px;-->
      <!--              top:-35px;-->
      <!--               border:none !important;-->
      <!--background-color: #efefef"-->
      <!--            @click="toSearch"-->
      <!--          >-->
      <!--            <el-image :src="require('@/assets/image/sousuo.png')"></el-image>-->
      <!--          </el-button>-->
      <!--        </div>-->
      <!--      </el-card>-->
      <div v-if="routelist[1].visible==1" class="includeQueryBar box mt20">
        <div class="search-box clear">
          <div style="margin-top: 20px">
            <span
              style="font-family: 微软雅黑;font-size: 22px;color: #404040;border-bottom: #004e96 3px solid;padding: 0px 5px"
              type="text">收录查询</span>
            <span
              style="font-size: 14px;font-family:微软雅黑;float: right;margin-top: 5px"
            >本系统共收录国内外标准<span style="color: #004a94">{{ systema.titleCount }}</span>条</span>
          </div>
          <div style="margin-top: 3px ;">
            <table class="tab01" style="border: 1px solid #efefef;width: 100% ;height: 170px">
              <tr style="border: 1px solid #efefef;">
                <th style="width: 232px;border-right: 1px solid #e4e4e4" @click='toStandarStatistical("国家标准")'>
                  <el-image :src="image1" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style=" font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">国家标准{{
                      systema.nationCount
                    }}项</span>
                  </div>
                </th>
                <th style="width: 232px;border-right: 1px solid #efefef" @click='toStandarStatistical("行业标准")'>
                  <el-image :src="image2" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style="font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">行业标准{{
                      systema.industryCount
                    }}项</span>
                  </div>
                </th>
                <th style="width: 232px;border-right: 1px solid #efefef" @click='toStandarStatistical("地方标准")'>
                  <el-image :src="image3" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style="font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">地方标准{{
                      systema.localCount
                    }}项</span>
                  </div>
                </th>
                <th style="width: 232px;border-right: 1px solid #efefef
              " @click='toStandarStatistical("工程标准")'>
                  <el-image :src="image4" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style="font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">技术规范{{
                      systema.engineeringCount
                    }}项</span>
                  </div>
                </th>
                <th style="width: 232px;border-right: 1px solid #efefef" @click='toStandarStatistical("国际国外")'>
                  <el-image :src="image5" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style="font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">国际国外{{
                      systema.internationalCount
                    }}项</span>
                  </div>
                </th>
                <th style="width: 232px" @click='toStandarStatistical("团体标准")'>
                  <el-image :src="image6" style="margin-top:20px;width: 40px;height: 36px"></el-image>
                  <br>
                  <div style="margin-top: 22px"><span
                    style="font-size: 16px;font-weight:normal;font-family: 微软雅黑;color:#000000 ;margin-top: 22px">团体标准{{
                      systema.groupCount
                    }}项</span>
                  </div>
                </th>
              </tr>
            </table>
          </div>
        </div>
      </div>


      <div v-if="routelist[2].visible==1" class="newsBar box mt20" style="position: relative">
        <!--        <el-row style="float: left">-->
        <!--          <el-col :offset="0" :span="2">-->
        <!--            <el-button style="width: 0px;-->
        <!--          padding: 0px;-->
        <!--          position: relative;-->
        <!--             left:0px;-->
        <!--              top:5px;-->
        <!--                    font-family:微软雅黑;font-size: 22px;color: #333333;"-->
        <!--                       type="text">标准动态-->
        <!--            </el-button>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <span
          style="z-index: 100;display: inline;position: absolute;left: 25px;top:16px;font-size: 22px;font-family: 微软雅黑;border-bottom: 3px #004e96 solid">标准动态</span>

        <el-tabs
          class="right-tabbox-newnotice"
          style="height: 360px;overflow: hidden;padding:10px 25px"
          v-model="tabname"
        >
          <el-tab-pane label="最新发布" style="max-height: 400px" name="first"
          >
            <standard-newest :num='8' :name="'page'"
            />
          </el-tab-pane>
          <!--          <el-tab-pane label="即将实施" style="max-height: 400px" name="second"
                    >
                      <standard-implementation :num='8' :name="'page'"
                      />
                    </el-tab-pane>
                    <el-tab-pane label="即将作废" style="max-height: 400px" name="third"
                    >
                      <standard-nullify :num='8' :name="'page'"
                      />
                    </el-tab-pane>-->
        </el-tabs>
        <el-row>
          <el-col style="margin-left: 1084px;padding-bottom: 15px;margin-top: 8px">
            <el-button
              class="el-bu"
              style="font-family: 微软雅黑;color: #b1b5b9;font-size: 16px"
              type="text"
              @click="toDetail('2')"
            >查看更多<i class="el-icon-d-arrow-right"></i>
            </el-button>
          </el-col>
        </el-row>
      </div>


      <div v-if="routelist[3].visible==1" style="display: flex">
        <!--        <el-card style="margin-top: 20px;margin-right:20px; width: 590px;height: 368px">-->
        <div class="newsBar box mt20" style="position: relative;width: 590px;height: 350px">
          <span
            style="z-index: 100;display: inline;position: absolute;left: 25px;top:21px;font-size: 22px;font-family: 微软雅黑;border-bottom: 3px #004e96 solid">政策法规</span>
          <el-row style="float: right;z-index: 1000">
            <el-col :offset="1" :span="2">
              <el-button
                class="el-bu"
                style="width: 0px;
          padding: 0px;
          position: relative;
             left:-60px;
              top:20px;font-family: 微软雅黑;color: #666666;font-size: 14px"
                type="text"
                @click="toDetail('3')"
              >更多<i class="el-icon-d-arrow-right"> </i></el-button
              >
            </el-col>
          </el-row>
          <el-tabs
            class="right-tabbox-newnotice"
            style="height: 320px;padding:10px 25px"
          >
            <el-tab-pane style="max-height: 270px"
            >
              <policy :num='7' :name="'page'"
              />
            </el-tab-pane>

          </el-tabs>
        </div>

        <!--        <el-card style="margin-top: 20px;width: 590px;height: 368px">-->
        <div class="newsBar box mt20" style="position: relative;width: 590px;height: 350px;margin-left: 20px">
          <span
            style="z-index: 100;display: inline;position: absolute;left: 25px;top:21px;font-size: 22px;font-family: 微软雅黑;border-bottom: 3px #004e96 solid">行业动态</span>

          <el-row style="float: right;z-index: 1000">
            <el-col :offset="1" :span="2">
              <el-button
                class="el-bu"
                style="width: 0px;
          padding: 0px;
          position: relative;
            left:-60px;
              top:20px;font-family: 微软雅黑;color: #666666;font-size: 14px"
                type="text"
                @click="toDetail('4')"
              >更多<i class="el-icon-d-arrow-right"></i></el-button
              >
            </el-col>
          </el-row>
          <el-tabs
            class="right-tabbox-newnotice"
            style="height: 320px;padding: 10px 25px"
          >
            <el-tab-pane style="max-height:  270px"
            >
              <news :num='7' :name="'page'"
              />
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>


      <div v-if="routelist[4].visible==1" class="newsBar box mt20" style="position: relative;height: 410px">
        <span
          style="z-index: 100;display: inline;position: absolute;left: 25px;top:17px;font-size: 22px;font-family: 微软雅黑;border-bottom: 3px #004e96 solid">工作动态</span>

        <el-tabs
          class="right-tabbox-newnotice" @tab-click="clickTab"

          style="height: 340px;padding: 10px 25px"
        >
          <el-tab-pane label="综合" style="max-height: 300px" tabname="first"
          >
            <announce :num='8' :name="'page'" :type='"0"'
            />
          </el-tab-pane>
          <el-tab-pane label="征求意见" style="max-height: 300px" tabname="first"
          >
            <announce :num='8' :name="'page'" :type='"1"'
            />
          </el-tab-pane>
          <el-tab-pane label="标准发布" style="max-height: 300px" tabname="first"
          >
            <announce :num='8' :name="'page'" :type='"2"'
            />
          </el-tab-pane>
          <el-tab-pane label="标准立项" style="max-height: 300px" tabname="first"
          >
            <announce :num='8' :name="'page'" :type='"3"'
            />
          </el-tab-pane>
          <el-tab-pane label="其他" style="max-height: 300px" tabname="first"
          >
            <announce :num='8' :name="'page'" :type='"99"'
            />
          </el-tab-pane>
          <!--          <el-tab-pane label="项目征集" style="max-height: 300px" tabname="second">
                      <project-collect :num='8' :name="'page'"/>
                    </el-tab-pane>-->
        </el-tabs>
        <el-row>
          <el-col style="margin-left: 1084px;padding-bottom: 60px;">
            <el-button
              class="el-bu"
              style="font-family: 微软雅黑;color: #b1b5b9;font-size: 16px"
              type="text"
              @click="toDetail('1')"
            >查看更多<i class="el-icon-d-arrow-right"></i>
            </el-button>
          </el-col>
        </el-row>
      </div>

      <div class="fot" v-if="false">
        <div class="newsBar box mt20">
          <el-row :gutter="20">
            <el-col
              :span="3"
              style="font-weight: bold;text-align: center;background-color:#c7c7c7 ;color: #004e96;padding: 15px 0px 15px 0px;font-size: 18px">
              <span>网站群</span>
            </el-col>
            <!--            <el-col :span="1" style="margin-top: 10px;height: 30px;border-left: 20px solid #c7c7c7;-->
            <!--    border-top: 15px solid transparent;-->
            <!--    border-bottom: 15px solid transparent;"></el-col>-->
            <el-col :span="3" style="font-size:16px;text-align: center;padding: 15px 0px 15px 0px;color: #666666">
              标准化技术委员会
            </el-col>
            <el-col :span="3" style="font-size:16px;text-align: center;padding: 15px 0px 15px 0px;color: #666666">
              标准化技术委员会
            </el-col>
            <el-col :span="3" style="font-size:16px;text-align: center;padding: 15px 0px 15px 0px;color: #666666">
              标准化技术委员会
            </el-col>
            <el-col :span="3" style="font-size:16px;text-align: center;padding: 15px 0px 15px 0px;color: #666666">
              标准化技术委员会
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../utils/request";
import {
  getSystemId,
  getSystemName,
  setSystemId,
  setSystemName,
} from "../../utils/systemInfo";
import News from "./compoment/news";
import Policy from "./compoment/policy";
import Announce from "./compoment/announce";
import ProjectCollect from "./compoment/projectCollect";
import StandardSystem from "./standardSystem";
import StandardNewest from "./compoment/standardNewest";
import StandardImplementation from "./compoment/standardImplementation";
import StandardNullify from "./compoment/standardNullify";
import NavigationBar from "./compoment/navigationBar";
import iamg1 from "../../../static/image/shouye.jpg"
import getSystem from "../../utils/getSystem";

export default {
  name: "page",
  components: {
    NavigationBar,
    StandardNullify,
    StandardImplementation,
    StandardNewest,
    StandardSystem,
    ProjectCollect,
    Announce,
    Policy,
    News,
    iamg1
  },
  data() {
    return {
      systema: {
        engineeringCount: '',//工程标准
        groupCount: '',//团体标准
        industryCount: '',//行业标准
        internationalCount: '',//国际国外标准
        localCount: '',//地方标准
        nationCount: '',//国家标准
        titleCount: ''//全部
      },
      system: '',
      tabname: 'first',
      routelist: [{}, {}, {}, {}, {}, {}],
      command: '全部',
      img11: require('../../../static/image/body-bg.jpg'),
      car: true,
      jp_list: [],
      sou: "../../../static/image/搜索.png",
      image1: require('../../../static/image/icon-include1.png'),
      image2: require('../../../static/image/icon-include2.png'),
      image3: require('../../../static/image/icon-include3.png'),
      image4: require('../../../static/image/icon-include4.png'),
      image5: require('../../../static/image/icon-include5.png'),
      image6: require('../../../static/image/icon-include6.png'),
      imageUrlTop: require('../../../static/image/home.jpg'),
      activeIndex: "1",
      input: "",
      systemInfo: {},
      belong: "",
      systemName: "",
    };
  },
  methods: {
    async querysystem() {
      await request({
        url: '/portalController/queryStandardCountForPortal',
        methods: 'get',
        params: {
          systemId: getSystemId()
        }
      }).then(rsp => {
        this.systema = rsp.data[0].columns
        console.log('接口', rsp)
      })
    },
    async query() {
      await request({
        url: '/portalController/getSlideshowAddress',
        methods: 'get',
        params: {
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.data && rsp.data.path) {
          let url = rsp.data.path.split(",");
          url.pop()
          this.jp_list = url
        }
      })
    },
    async getRouteList() {
      await request({
        url: 'portalController/getModule',
        methods: 'get',
        params: {
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          console.log('rsp', rsp.data)
          this.routelist = rsp.data
          // let url=rsp.data.imageurl.split(",");
          // url.pop()
          // this.jp_list=url
        }
      })
    },
    handleCommand(command) {
      this.command = command
      if (command == '国家标准') {
        this.system = 'G'
      }
      if (command == '行业标准') {
        this.system = 'C'
      }
      if (command == '地方标准') {
        this.system = 'D'
      }
      if (command == '团体标准') {
        this.system = 'T'
      }
      if (command == '国际国外标准') {
        this.system = 'N'
      }
      if (command == '工程标准') {
        this.system = 'J'
      }
      if (command == '技术规范') {
        this.system = 'Z'
      }
    },
    carousel() {
      this.car = false
    },
    toStandarStatistical(command) {
      let system = ''
      if (command == '国家标准') {
        system = 'G'
      }
      if (command == '行业标准') {
        system = 'C'
      }
      if (command == '地方标准') {
        system = 'D'
      }
      if (command == '团体标准') {
        system = 'T'
      }
      if (command == '国际国外') {
        system = 'N'
      }
      if (command == '工程标准') {
        system = 'J'
      }
      if (command == '技术规范') {
        this.system = 'Z'
      }
      this.$router.push({path: "/standardStatistical", query: {input: null, system: system}});
    },
    /**
     * 获取系统信息
     */
    async getSystem() {
      await request({
        url: "/systemName",
        method: "get",
        params: {
          domain: document.domain,
          // domain: 'szsd.aibz.online'
        },
      }).then((rsp) => {
        if (rsp.resultCode === "0" && !!rsp.data) {
          this.systemInfo = rsp.data;
          setSystemId(this.systemInfo.id);
          setSystemName(this.systemInfo.name);
          document.title = this.systemInfo.name;
          this.belong = getSystemId();
          this.systemName = getSystemName();
        } else {
          this.$router.push("/404");
        }
      });
    },
    /**
     *
     */
    clickTab(tab) {
      this.tabname = tab.$attrs.tabname
    },
    /**
     * 跳转详情页
     */
    toDetail(index) {
      this.$router.push({path: "/detail", query: {index: index, id: null, name: this.tabname}});
    },
    /**
     * 跳转标准查询页
     */
    toSearch() {
      this.$router.push({path: "/standard", query: {input: this.input, system: this.system}});
    },
  },
  async mounted() {
  },
  async created() {
    await this.getSystem();
    await this.getRouteList()
    await this.query()
    await this.querysystem()
  },
};
</script>


<style scoped>
.page {
  background: url("../../../static/image/back.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size: 100% 775px;
}

.inpu >>> .el-input__inner {
  border-radius: 25px 25px 25px 25px !important;
  height: 50px;
  background: #efefef;
  border: 1px solid #efefef;
}

.inpu >>> .el-input__inner:hover {
  border: 1px solid #dcdfe6;
}

.son1 {
  background-color: blue;
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 300px;
  border: 1px solid black;
}

ul {
  padding: 0;
  margin: 0;
  font-family: "微软雅黑";
}

li {
  list-style: none;
  float: left;
}

.floatL {
  float: left;
}

.floatR {
  float: right;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px !important;
}

.mb20 {
  margin-bottom: 20px;
}

.none {
  display: none;
}

.color-sure {
  color: #004e96;
}

.clear::after,
ul::after {
  display: block;
  content: "";
  height: 0;
  clear: both;
}

a,
a:visited {
  color: #666;
  text-decoration: none;
}

a:hover {
  color: #004e96;
  text-decoration: underline;
}

.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

header {
  height: 110px;
  text-align: left;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  line-height: 110px;
}

.nav {
  width: 100%;
  min-width: 1200px;
  height: 65px;
  background-color: #004e96;
}

.nav li {
  height: 65px;
  line-height: 65px;
  color: #fff;
  padding: 0 30px;
  font-size: 18px;
  cursor: pointer;
}


.banner {
  height: 325px;
}

.newsBar-half {
  width: 590px;
}

.newsBar .title {
  margin-top: 10px;
  line-height: 50px;
  height: 50px;
  margin: 10px 25px;
  border-bottom: #e4e4e4 1px solid;
}

.newsBar .title label {
  display: inline-block;
  padding: 0 5px;
  border-bottom: #004e96 3px solid;
  height: 48px;
  font-size: 22px;
  color: #404040;
}

.newsBar .title ul {
  float: right;
}

.newsBar .title li {
  padding: 0 10px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.newsBar .title li.active {
  color: #004e96;
  font-weight: bold;
}

.newsBar .title li:hover {
  color: #004e96;
}

.newsBar .title a {
  font-size: 14px;
  float: right;
}

.newsBar .content {
  margin: 20px;
}

.newsBar .content ul {
  min-height: 250px;
}

.newsBar .content li {
  width: 100%;
}

.newsBar .content li label,
.newsBar .content li span {
  display: block;
  height: 35px;
  line-height: 35px;
}

.newsBar .content li label {
  float: left;
  width: 1000px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.newsBar-half .content li label {
  width: 430px;
}

.newsBar .content li span {
  float: right;
}

.newsBar .content li:hover label,
.newsBar .content li:hover span {
  text-decoration: underline;
  color: #004e96;
  cursor: pointer;
}

.newsBar .content a {
  display: block;
  text-align: right;
  margin: 10px 0;
}

.siteMap {
  width: 100%;
  line-height: 50px;
}

.siteMap label {
  width: 110px;
  background-color: #c7c7c7;
  color: #004e96;
  font-size: 18px;
  display: inline-block;
  text-align: center;
  line-height: 51px;
}

.siteMap a {
  margin: 0 10px;
}

footer {
  width: 100%;
  min-width: 1200px;
  margin-top: 20px;
  background-color: #004e96;
  height: 170px;
  padding-top: 40px;
  line-height: 32px;
  text-align: center;
  color: #b8c2ef;
}

footer .adver {
  position: absolute;
  top: 50%;
  margin-top: -25px;
  height: 50px;
  right: 0;
}

footer .adver a {
  margin-right: 10px;
}

.son2 {
  background-color: blueviolet;
  position: absolute;
  transform: translate(100%, 0);
  width: 50%;
  height: 300px;
}
</style>
<style>
.page .el-tabs__active-bar {
  background-color: transparent !important;
}

.right-tabbox-newnotice /deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}

.right-tabbox-newnotice /deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}

.page .el-tabs__nav {
  float: right !important;
}

.page .el-tabs__item {
  font-family: 微软雅黑;
  color: #333333;
  font-size: 16px;
}

.page .is-active {
  color: #004e96;
  font-weight: bold;;
}

.fot .el-card__body {
  padding: 0px;
}

.butt .el-button:hover {
  background: #efefef;
}

.page .el-tabs__header {
  margin: 0 0 10px !important;
}

/*.el-table .cell {*/
/*  padding-left: 8px !important;*/
/*}*/
.el-dropdown-link {
  cursor: pointer;
  color: #000000;
}

.el-icon-arrow-down {
  font-size: 16px;
  font-family: 微软雅黑;
}

.box {
  background-color: #fff;
  box-shadow: #666 0 0 5px;
  border-radius: 2px;
}

.searchBar {
  height: 50px;
  padding: 25px 35px;
}

.searchBar .search-box {
  width: 1130px;
  height: 30px;
  background-color: #f3f3f3;
  border-radius: 25px;
  padding: 10px 0;
}

.searchBar .search-box .typeList {
  float: left;
  width: 95px;
  height: 30px;

  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.searchBar .search-box .btnSearch {
  width: 30px;
  height: 30px;
  background: url(../../assets/image/sousuo.png) no-repeat center;
  border: none;
  outline: none;
  cursor: pointer;
  float: left;
  margin-left: -10px;
}

.searchBar .search-box .inputSearch {
  width: 980px;
  height: 30px;
  line-height: 30px;
  border: none;
  background: transparent;
  outline: none;
  margin-left: 10px;
  border-left: #d1d1d1 1px solid;
  padding-left: 10px;
  float: left;
}

.searchBar .search-box .inputSearch::placeholder {
  color: #d1d1d1;
}

.includeQueryBar {
  width: 1100px;
  padding: 0 50px;
  height: 245px;
  overflow: hidden;
}

.includeQueryBar .title {
  margin-top: 20px;
  line-height: 30px;
}

.includeQueryBar .title label {
  font-size: 22px;
  color: #404040;
  float: left;
  display: inline-block;
  border-bottom: #004e96 3px solid;
  padding: 0 5px;
}

.includeQueryBar .title span {
  color: #404040;
  font-size: 14px;
  float: right;
}

.includeQueryBar ul {
  width: 1100px;
  height: 150px;
  border: #e4e4e4 1px solid;
  box-sizing: border-box;
}

.includeQueryBar ul li {
  width: 20%;
  height: 100%;
  border-right: #e4e4e4 1px solid;
  box-sizing: border-box;
}

.includeQueryBar ul li i {
  display: block;
  width: 50px;
  height: 50px;
  margin: 25px auto;
  background: no-repeat center;
  background-size: 80%;
}

.includeQueryBar ul li label {
  display: block;
  text-align: center;
}

.includeQueryBar ul li:last-child {
  border-right: none;
}

.newsBar {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/home/page.vue